export default "__VITE_ASSET__AFCzhiCe__"